<template>
    <div id="submenus" class="cf mw9 bg-black pb2">
      <div class="fl w-third-ns w-100 bg-black white-90" id="aboutmenu">
        <h3 class="tc">About Daniel's Brain</h3>
        <p class="pt2 pl2 ml2 mr2">Daniel Gallo is a personality from the Dudley and Bob With Matt
          morning show on KLBJ FM 93.7 in Austin, Texas. He says wild and wonderful
          things, that are sometimes even (sort of) true.
        </p>
      </div>
      <div class="fl w-third-ns w-100 white-90 bg-black h-100" id="moremenu">
        <h3 class="tc">Get More Daniel's Brain</h3>
        <div class= "flex flex-column" id="morelinksdiv">
          <div class="mb2 mt2 fl tc">
              <a v-on:click="onClick" class="link blue ml3" href="#">Wordcloud of Daniel's Thoughts</a>
          </div>
          <!-- end wordcloud div -->
          <div class="mb2 fl tc">
              <a class = "link blue ml3" href="https://www.amazon.com/Goody-Apps-Good-Daniels-Brain/dp/B06XSYF3QQ">
              Get Daniel's Brain on Alexa</a></div>
              <div class="center tc w-100 fl">
                  <img src="static/alexa_badge.svg" class="mw4 center"/>
              </div>
              <div class="mb2 fl tc">
              <!-- Coming soon to Google Assistant</div>               -->
              <div class="center tc w-100 fl">
                
                  <img src="static/assistant.png" class="mw4 center"/>
              </div>
              </div>
        </div>
        <!-- end alexa div -->
      </div>
      <!-- end morelinksdiv  -->
      <!-- test -->
      <div class="fl w-third-ns w-100 white-90 bg-black h-100" id="linksmenu">
        <h3 class="tc">Links</h3>
        <div class= "flex flex-column" id="linkslist">
          <div class="flex flex-row items-center fl ml2" title="dbmtwitter">
            <div>
              <a class="link blue dib w2" href="http://twitter.com/DudleyandBob" title="">
              <svg data-icon="twitter" viewBox="0 0 512 512" style="fill:currentcolor">
              <title>twitter icon</title>
              <path d="M419.6 168.6c-11.7 5.2-24.2 8.7-37.4 10.2 13.4-8.1 23.8-20.8 28.6-36 -12.6 7.5-26.5 12.9-41.3 15.8 -11.9-12.6-28.8-20.6-47.5-20.6 -42 0-72.9 39.2-63.4 79.9 -54.1-2.7-102.1-28.6-134.2-68 -17 29.2-8.8 67.5 20.1 86.9 -10.7-0.3-20.7-3.3-29.5-8.1 -0.7 30.2 20.9 58.4 52.2 64.6 -9.2 2.5-19.2 3.1-29.4 1.1 8.3 25.9 32.3 44.7 60.8 45.2 -27.4 21.4-61.8 31-96.4 27 28.8 18.5 63 29.2 99.8 29.2 120.8 0 189.1-102.1 185-193.6C399.9 193.1 410.9 181.7 419.6 168.6z"></path>
             </svg></a>
            </div>
            <div>
              <a class="link blue fl" href="http://twitter.com/DudleyandBob">Dudley and Bob with Matt</a>
            </div>
          </div>
          <div class="flex flex-row items-center fl ml2" title="gallotwitter">
            <div>
              <a class="link blue dib w2" href="http://twitter.com/thedanielgallo" title="">
              <svg data-icon="twitter" viewBox="0 0 512 512" style="fill:currentcolor">
              <title>twitter icon</title>
              <path d="M419.6 168.6c-11.7 5.2-24.2 8.7-37.4 10.2 13.4-8.1 23.8-20.8 28.6-36 -12.6 7.5-26.5 12.9-41.3 15.8 -11.9-12.6-28.8-20.6-47.5-20.6 -42 0-72.9 39.2-63.4 79.9 -54.1-2.7-102.1-28.6-134.2-68 -17 29.2-8.8 67.5 20.1 86.9 -10.7-0.3-20.7-3.3-29.5-8.1 -0.7 30.2 20.9 58.4 52.2 64.6 -9.2 2.5-19.2 3.1-29.4 1.1 8.3 25.9 32.3 44.7 60.8 45.2 -27.4 21.4-61.8 31-96.4 27 28.8 18.5 63 29.2 99.8 29.2 120.8 0 189.1-102.1 185-193.6C399.9 193.1 410.9 181.7 419.6 168.6z"></path>
              </svg></a>
            </div>
             <div>
              <a class="link blue fl" href="http://twitter.com/thedanielgallo">Daniel Gallo</a>
            </div>
          </div>
          <div class="flex flex-row ml2 items-center " title="richtwitter">
            <div><a class="link blue dib w2" href="http://twitter.com/rgoodwin" title="">
              <svg data-icon="twitter" viewBox="0 0 512 512" style="fill:currentcolor">
              <title>twitter icon</title>
              <path d="M419.6 168.6c-11.7 5.2-24.2 8.7-37.4 10.2 13.4-8.1 23.8-20.8 28.6-36 -12.6 7.5-26.5 12.9-41.3 15.8 -11.9-12.6-28.8-20.6-47.5-20.6 -42 0-72.9 39.2-63.4 79.9 -54.1-2.7-102.1-28.6-134.2-68 -17 29.2-8.8 67.5 20.1 86.9 -10.7-0.3-20.7-3.3-29.5-8.1 -0.7 30.2 20.9 58.4 52.2 64.6 -9.2 2.5-19.2 3.1-29.4 1.1 8.3 25.9 32.3 44.7 60.8 45.2 -27.4 21.4-61.8 31-96.4 27 28.8 18.5 63 29.2 99.8 29.2 120.8 0 189.1-102.1 185-193.6C399.9 193.1 410.9 181.7 419.6 168.6z"></path>
             </svg></a>
            </div>
            <div><a class="fl link blue" href="http://twitter.com/rgoodwin">Richard Goodwin</a>
            </div>
          </div>
          <div class="flex flex-row dib items-center ml2" title="dbmlink">
              <div>
                <a class="link blue dib w2" href="http://www.klbjfm.com/dbmshow" title="">
               <svg viewBox="0 0 512 512" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;">
                <g transform="matrix(1,0,0,1,26.2311,26.2311)">
                    <path d="M209,15C102.405,15.547 15,103.401 15,209.997C15,316.971 103.026,404.997 210,404.997C316.974,404.997 405,316.971 405,209.997C405,103.401 317.595,15.547 211,15L209,15ZM210,15L210,405M405,210L15,210M59,90C149.124,154.296 270.876,154.296 361,90M361,330C270.876,265.704 149.124,265.704 59,330M195,20C138.786,67.474 106.304,137.422 106.304,211C106.304,284.578 138.786,354.526 195,402M225,402C281.214,354.526 313.696,284.578 313.696,211C313.696,137.422 281.214,67.474 225,20" style="fill:none;stroke:rgb(53,126,221);stroke-width:20px;"/>
                </g>
               </svg>
               </a>
              </div>
              <div class="w-85">
                <a class="link blue fl measure" href="http://www.klbjfm.com/dbmshow">Dudley & Bob with Matt</a>
            </div>
          </div>

           <div class="flex flex-row dib items-center ml2" title="dbmlink">
              <div>
              <a class="link blue dib w2" href="https://oiaradio.libsyn.com/" title="">
              <svg viewBox="0 0 512 512" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;">
                <g transform="matrix(1,0,0,1,26.2311,26.2311)">
                    <path d="M209,15C102.405,15.547 15,103.401 15,209.997C15,316.971 103.026,404.997 210,404.997C316.974,404.997 405,316.971 405,209.997C405,103.401 317.595,15.547 211,15L209,15ZM210,15L210,405M405,210L15,210M59,90C149.124,154.296 270.876,154.296 361,90M361,330C270.876,265.704 149.124,265.704 59,330M195,20C138.786,67.474 106.304,137.422 106.304,211C106.304,284.578 138.786,354.526 195,402M225,402C281.214,354.526 313.696,284.578 313.696,211C313.696,137.422 281.214,67.474 225,20" style="fill:none;stroke:rgb(53,126,221);stroke-width:20px;"/>
                </g>
               </svg>
               </a>
              </div>
              <div class="w-85">
                <a class="link blue fl" href="https://oiaradio.libsyn.com/">Daniel's OIA Radio Podcast</a>
            </div>
            </div>

        </div>
      </div>
    </div>
    <!-- end submenus div -->

</template>

<script>
export default {
  props: {
    onClick: {
      type: Function,
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Submenu.vue